import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CalenderResponse, CalenderFiltersResponse, CreateScheduleRequest, CalenderDynamicRequest, CreateScheduleResponse, CalenderSchedulerResponse, TimeSlotsRequest, TimeSlotsResponse } from '../../models/contact-modal/calender.model';
import { eCalenderView, eMailingStatus, eApptStatus, eTaskStatus } from '../../models/contact-modal/enum.model';
import { SimpleResponse } from '../../models/contact-modal/genericResponse.model';
import { ScheduleAppointmentRequest, ScheduleAppointmentResponse } from '../../models/contact-modal/scheduler.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class MyCalenderService {
    private baseUrl: string;
    private api: string = "api/Engage/Calender";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async calenderDataByMonth(encryptedUser: string, clpCompanyId: number, userId: number, forMonth: number, eMailingStatus, eApptStatus, dtStart): Promise<CalenderResponse | void> {
        const a = await this.httpClient
            .get<CalenderResponse>(`${this.baseUrl}/CalenderData_timeWise/${clpCompanyId}/${userId}/${forMonth}?mailStatus=${eMailingStatus}&&apptStatus=${eApptStatus}&&dtEnd=''&&dtStart=${dtStart}&&taskStatus=0`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "userId - " + userId + "forMonth - " + forMonth + "forMonth - " + eMailingStatus + "eApptStatus - " + eApptStatus + "dtStart - " + dtStart, encryptedUser, "MyCalenderService", "calenderDataByMonth"); });

        return a;
    }

    async calenderFilters(encryptedUser: string, clpuserID: number, clpCompanyId: number): Promise<CalenderFiltersResponse | void> {
        const a = await this.httpClient.get<CalenderFiltersResponse>(`${this.baseUrl}/Calender_Get_Filters/${clpCompanyId}/${clpuserID}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserID - " + clpuserID + "," + "clpCompanyId - " + clpCompanyId, encryptedUser, "MyCalenderService", "calenderFilters") });
        return a;
    }

    async calenderDataGet(encryptedUser: string, clpuserID: number, clpCompanyId: number, selectedTeamCode: number, selectedofficeCode: number, selectedMonth: string, calenderView: eCalenderView, selectedUserID: number, mailStatus: eMailingStatus, apptStatus: eApptStatus, taskStatus: eTaskStatus, selectCalDate: SimpleResponse): Promise<CalenderResponse | void> {
        const a = await this.httpClient.post<CalenderResponse>(`${this.baseUrl}/CalenderData_Get/${clpuserID}/${clpCompanyId}/${selectedTeamCode}/${selectedofficeCode}/${selectedMonth}/${calenderView}/${selectedUserID}/${mailStatus}/${apptStatus}/${taskStatus}`, selectCalDate, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, selectCalDate, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "clpuserID - " + clpuserID + "selectedTeamCode - " + selectedTeamCode + "selectedofficeCode - " + selectedofficeCode + "selectedMonth - " + selectedMonth + "calenderView - " + calenderView + "selectedUserID - " + selectedUserID + "mailStatus - " + mailStatus + "apptStatus - " + apptStatus + "taskStatus - " + taskStatus, encryptedUser, "MyCalenderService", "calenderDataGet"); });
        return a;
    }

    async taskUpdateDtDue(encryptedUser: string, strOldDate: string, StrNewDate: string, clpuserID: number, clpCompanyId: number, status: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/Task_Update_DtDue/${strOldDate}/${StrNewDate}/${clpuserID}/${status}/${clpCompanyId}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "strOldDate - " + strOldDate + "," + "StrNewDate - " + StrNewDate + "," + "clpuserID - " + clpuserID + "," + "status - " + status, encryptedUser, "MyCalenderService", "taskUpdateDtDue") });
        return a;
    }

    async calenderDynamicLoad(calenderDynamicRequest: CalenderDynamicRequest): Promise<CalenderSchedulerResponse | void> {
        const a = await this.httpClient.post<CalenderSchedulerResponse>(`${this.baseUrl}/CalenderDynamic_Load`, calenderDynamicRequest, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic '
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, calenderDynamicRequest, "", "MyCalenderService", "CalenderDynamicLoad") });
        return a;
    }

    async Schedule_Create(request: CreateScheduleRequest): Promise<CreateScheduleResponse | void> {
        const a = await this.httpClient.post<CreateScheduleResponse>(`${this.baseUrl}/Schedule_Create`, request, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic '
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, request, "", "MyCalenderService", "Schedule_Create"); });
        return a;
    }

    async buildTimeSlots(encryptedUser: string, request: TimeSlotsRequest): Promise<TimeSlotsResponse | void> {
        const a = await this.httpClient.post<TimeSlotsResponse>(`${this.baseUrl}/BuildTimeSlots`, request, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, request, encryptedUser, "MyCalenderService", "BuildTimeSlots"); });
        return a;
    }

}

